module.exports = __webpack_public_path__ + "static/media/riverbird.2cd40a0d.png";